import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StagingAuthService {
  private readonly AUTH_KEY = 'basic_auth_token';

  login(username: string, password: string): boolean {
    if (this.isValidCredentials(username, password)) {
      const credentials = `${username}:${password}`;
      const encodedCredentials = this.safeBase64Encode(credentials);
      localStorage.setItem(this.AUTH_KEY, encodedCredentials);
      return true;
    }
    return false;
  }

  logout(): void {
    localStorage.removeItem(this.AUTH_KEY);
    window.location.reload();
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem(this.AUTH_KEY);
    if (!token) {
      return false;
    }

    try {
      const decodedCredentials = this.safeBase64Decode(token);
      const [username, password] = this.splitCredentials(decodedCredentials);
      return this.isValidCredentials(username, password);
    } catch {
      return false;
    }
  }

  private isValidCredentials(username: string, password: string): boolean {
    return (
      username === environment.stagingAuth?.username &&
      password === environment.stagingAuth?.password
    );
  }

  private safeBase64Encode(str: string): string {
    const utf8Bytes = new TextEncoder().encode(str);
    let binaryStr = '';
    utf8Bytes.forEach((byte) => {
      binaryStr += String.fromCharCode(byte);
    });
    return btoa(binaryStr);
  }

  private safeBase64Decode(base64: string): string {
    const binaryStr = atob(base64);
    const utf8Bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      utf8Bytes[i] = binaryStr.charCodeAt(i);
    }
    return new TextDecoder().decode(utf8Bytes);
  }

  private splitCredentials(decodedCredentials: string): [string, string] {
    const firstColonIndex = decodedCredentials.indexOf(':');
    if (firstColonIndex === -1) {
      throw new Error('Invalid credential format');
    }

    const username = decodedCredentials.substring(0, firstColonIndex);
    const password = decodedCredentials.substring(firstColonIndex + 1);

    return [username, password];
  }
}
